import { plainToInstanceWithLVS } from '@goparrot/common';
import { stringify } from 'qs';
import { BaseFacade } from '../../../common';
import { ListOrderResponseDto } from '../../dto';
import { OrderExposeGroup } from '../../interface';
export class OrderV3Facade extends BaseFacade {
    async list(body, pagination) {
        const { data } = await this.client.put('/api/v3/orders', body, {
            params: pagination,
            paramsSerializer: (params) => stringify(params),
        });
        return plainToInstanceWithLVS(ListOrderResponseDto, data, { groups: [OrderExposeGroup.LIST], excludeExtraneousValues: true, exposeUnsetFields: true });
    }
}
//# sourceMappingURL=OrderV3Facade.js.map